const SPACE_VALUES = ['flush', 'half', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
const SPACE_SIDES = ['top', 'bottom', 'left', 'right'];

export { SPACE_SIDES, SPACE_VALUES };
